import { Col, Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { MenuFooter } from '@/app/components/MenuFooter/MenuFooter'
import { Motion } from '@/app/components/Motion/Motion'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { useMedia } from '@/app/hooks/useMedia'
import { useNavigate, useNavigateSearchParams } from '@/app/hooks/useNavigate'
import type { FunctionalComponent } from 'preact'
import { useLayoutEffect } from 'preact/hooks'

export const ChatsPage: FunctionalComponent = () => {
  const [params, navigate] = useNavigateSearchParams()
  const route = useNavigate()
  const isMobile = useMedia(1023)

  useLayoutEffect(() => {
    const redirect = params.get('redirect')

    if (redirect) {
      if (isMobile) {
        navigate((prev) => {
          const next = new URLSearchParams(prev)
          next.delete('redirect')
          return next
        }, {
          replace: true,
        })

        route(redirect)
      }
      else {
        route(redirect, { replace: true })
      }
    }
    else if (!isMobile) {
      route('~/chats/zoe', { replace: true })
    }
  }, [isMobile])

  return (
    <Layout>
      <Layout.Content>
        <Layout.HeadMenu />

        <Row gap={15} flexGrow={1}>
          <Motion>
            <Row gap={10}>
              <UI.Panel
                hover
                radius='l'
                link='~/chats/zoe'
              >
                <Col gap={15} alignItems='center'>
                  <UI.Avatar bot='zoe' size={64} />

                  <Row gap={4}>
                    <Text fontWeight={600} fontSize={18}>
                      Зоя
                    </Text>
                    <Text fontSize={14} opacity={0.5}>
                      Натальная карта
                    </Text>
                  </Row>
                </Col>
              </UI.Panel>

              <UI.Panel
                hover
                radius='l'
                link='~/chats/milana'
              >
                <Col gap={15} alignItems='center'>
                  <UI.Avatar bot='milana' size={64} />

                  <Row gap={4}>
                    <Text fontWeight={600} fontSize={18}>
                      Милана
                    </Text>
                    <Text fontSize={14} opacity={0.5}>
                      Матрица судьбы
                    </Text>
                  </Row>
                </Col>
              </UI.Panel>

              <UI.Panel
                hover
                radius='l'
                link='~/chats/eva'
              >
                <Col gap={15} alignItems='center'>
                  <UI.Avatar bot='eva' size={64} />

                  <Row gap={4}>
                    <Text fontWeight={600} fontSize={18}>
                      Ева
                    </Text>
                    <Text fontSize={14} opacity={0.5}>
                      Таро
                    </Text>
                  </Row>
                </Col>
              </UI.Panel>
            </Row>
          </Motion>
        </Row>

        <MenuFooter />
      </Layout.Content>
    </Layout>
  )
}
